import api from './api';

export interface AuditLog {
  id: string;
  apiName: string;
  method: string;
  endpoint: string;
  userId?: string;
  userName?: string;
  userEmail?: string;
  ipAddress?: string;
  dbTable?: string;
  dbRowId?: string;
  requestBody?: string;
  responseStatus?: string;
  createdAt: string;
}

export interface AuditLogsResponse {
  logs: AuditLog[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
}

export interface AuditLogsParams {
  page?: number;
  limit?: number;
  startDate?: string;
  endDate?: string;
  userId?: string;
  apiName?: string;
  method?: string; // legacy single-method support
  methods?: string[];
  search?: string;
}

export const auditApi = {
  getAll: async (params?: AuditLogsParams): Promise<AuditLogsResponse> => {
    const query: Record<string, unknown> = { ...(params || {}) };

    if (params?.methods !== undefined) {
      query.methods = params.methods.join(',');
    } else {
      delete query.methods;
    }

    const { data } = await api.get('/audit', { params: query });
    return data;
  },
};
